module.exports = __webpack_public_path__ + "static/media/waves-project.6ccf7039.JPG";